import { SensorData } from 'Simulations/SensorPoint';
import { FilterStage, StageParameters } from '../../Stage';
import { StageContext } from '../../Context';
import { isPointInPolygon } from '@data/geometry/Functions';
import FVector from '@data/geometry/FVector';

export interface InsidePolygonStageParameters extends StageParameters {
    polygon: FVector[]; // Array of 2D points defining the polygon
    invert?: boolean;
}

class InsidePolygonStage extends FilterStage<InsidePolygonStageParameters> {
    protected filter(sensorData: SensorData, _context: StageContext): boolean {
        const position = sensorData.getPosition();
        const point2D = new FVector(position.x, position.y);

        // Check if the point is inside the Polygon using raycasting:
        const isInside = isPointInPolygon(point2D, this.getParams().polygon);
        return this.getParams().invert ? !isInside : isInside;
    }
}

export default InsidePolygonStage;
